import 'bootstrap';
import '@dotlottie/player-component';
import rddl from './plugins/rddl';
import 'jquery-match-height';

window.jQuery = window.$ = jQuery;
import $ from 'jquery';

import ready, { HTML } from './utils';
import './plugins/responsiveHelperPlugin';
import initOpenClose from './components/openClose';
import initAccordion from './components/accordion';
import initFancybox from './components/fancybox';
import initSlickCarousel from './components/slickSlider';
import initTabs from './components/tabs';
import initVivus from './components/vivus';
import initAOS from './components/aos';
import initStickyScrollBlock from './components/stickyScrollBlock';
import initAnchors from './components/anchors';
import initCustomForms from './components/customscroll';
import { each } from 'jquery';
import initSelect2 from './components/select2';
import initThankYouCalendar from './components/thankYouCalendar';
import initMarketo from './components/marketo';
import initEbook from './components/ebook';
import initInfiniteSlide from './components/infiniteSlide';
import initM66 from './components/m66-slider';
import Navigation from './components/navigation';
// import Blog from './components/blog';
import initM17 from './components/m17';
import initM43 from './components/m43';
import initM45 from './components/m45';
import initM70 from './components/m70';
import initM74 from './components/m74';
import initM75 from './components/m75';
import initM77 from './components/m77';
import initM82 from './components/m82';
import initFloatingCTA from './components/floating-cta';
import initResponsiveTabs from './components/easyResponsiveTabs';
import ResourceArchive from './components/resource-archive';
import initM87 from './components/m87';
import initM30 from './components/m30';
import Search from './components/search';
import CustomerStoryDetail from './components/CustomerStoryDetail';
import M107 from './components/m107';
import DefaultMarketoForm from './components/default-marketo-form';
import BlogGridSubscribeForm from './components/blog-grid-subscribe-form';
import BlogSubscribeBanner from './components/blog-subscribe-banner';
import M72 from './components/m72';
import M73 from './components/m73';
import initM111 from './components/m111';
import M9 from './components/m9';
import SmoothScroll from './utils/smoothScroll';
import OntraLottie from './components/lottie';
import M1 from './components/m1';
import M95 from './components/m95';
import M32 from './components/m32';
import initM119 from './components/m119';
import M122 from './components/m122';
import FooterSubscribeForm from './components/footer-subscribe-form';
import M136 from './components/m136';
import M158 from './components/m158';
import M120 from './components/m120';
import CopyToClipboard from './components/copyToClipboard';
import DropdownFilter from './components/dropdown-filter';
import M53 from './components/m53';
import BlogSidebarSticky from './components/blogSidebarSticky';
import M104 from './components/m104';
import M163 from './components/m163';
import SubscribeShortcode from './components/subscribe-shortcode';
import M92 from './components/m92';
import M108 from './components/m108';
import M94 from './components/m94';
import MarketoUTMs from './components/marketoUtms';
import M167 from './components/m167';

ready(() => {
  initRddl();
  initTabs();
  initAccordion();
  initVivus();
  initOpenClose();
  initFancybox();
  initAlert();
  initListSort();
  initStickyScrollBlock();
  //initTitleHeight();
  initFormCleaner();
  initAnchors();
  initAOS();
  initCustomForms();
  initSelect2();
  initThankYouCalendar();
  initMarketo();
  new DefaultMarketoForm();
  BlogSubscribeBanner.init();
  BlogGridSubscribeForm.init();
  initEbook();
  initInfiniteSlide();
  //initAuthor();
  M1.init();
  M9.init();
  initM66();
  initM17();
  initM30();
  initM43();
  initM45();
  initM70();
  M72.init();
  M73.init();
  initM74();
  initM75();
  initM77();
  initM82();
  M104.init();
  initM87();
  M92.init();
  M94.init();
  initM119();
  M95.init();
  M107.init();
  M122.init();
  initFloatingCTA();
  initResponsiveTabs();
  ResourceArchive.init();
  initSlickCarousel();
  M32.init();
  BlogSidebarSticky.init();
  new Search();
  CustomerStoryDetail.init();
  initM111();
  SmoothScroll.init();
  OntraLottie.init();
  FooterSubscribeForm.init();
  M136.init();
  initHeaderHeight();
  M158.init();
  M120.init();
  CopyToClipboard.init();
  DropdownFilter.init();
  M53.init();
  M163.init();
  SubscribeShortcode.init();
  M108.init();
  // MarketoUTMs.init();
  M167.init();

  const nav = new Navigation();
  // const blog = new Blog();

  HTML.classList.add('is-loaded');
});
document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    setTimeout(function () {
      jQuery('.lightbox').click();
    }, 1000);
  },
  false
);

function initRddl() {
  // Wait for gtag to be available
  (async () => {
    while (!window.hasOwnProperty('gtag')) await new Promise((resolve) => setTimeout(resolve, 500));

    window.gtag('get', 'G-EYJRG6JW4M', 'client_id', (client_id) => {
      window.rddl.init(client_id, {
        component_class: 'module',
        form_class: 'mktoForm',
        form_ignore_fields: [
          'formid',
          'munchkinId',
          'utm_campaign__c',
          'utm_medium__c',
          'utm_source__c',
          'utm_content__c',
          'utm_term__c',
          'GCLID__c', // ?
        ],
        //is_testing:         true,
        munchkin_id: '934-BAM-030',
      });

      // Page detail dataLayer
      window.rddl.global({
        event: 'page_view',
        page_detail: {
          page_title: 'page.title',
          page_url: 'page.url',
          page_template: 'page.template',
          published_date: 'page.published_date',
          author: 'page.author',
        },
        user_info: {
          client_id: 'user.client_id',
          munchkin_id: 'user.munchkin_id',
        },
      });

      // Internal link click (body)
      window.rddl.click('.main-wrapper a', {
        event: 'link_click',
        link_text: 'link.text',
        link_url: 'link.url',
        link_location: 'link.component',
        page_url: 'page.url',
      });

      // Navigation menu click (header)
      window.rddl.click('header a', {
        event: 'menu_click',
        link_text: 'link.text',
        link_url: 'link.url',
        link_location: 'Top Menu',
        page_url: 'page.url',
      });

      // Navigation menu click (footer)
      window.rddl.click('footer.footer a', {
        event: 'menu_click',
        link_text: 'link.text',
        link_url: 'link.url',
        link_location: 'Footer',
        page_url: 'page.url',
      });

      // Marketo Form - Start
      window.rddl.marketo('start', {
        event: 'form_start',
        mkto_form_id: 'form.marketo_form_id',
        form_name: '',
        form_url: 'page.url',
        client_id: 'user.client_id',
        munchkin_id: 'user.munchkin_id',
      });

      // Marketo Form - Submit
      window.rddl.marketo('submit', {
        event: 'form_submit',
        mkto_form_id: 'form.marketo_form_id',
        form_fields: '',
        form_field: 'form.fields_filled',
        form_url: 'page.url',
        client_id: 'user.client_id',
        munchkin_id: 'user.munchkin_id',
      });

      // Marketo Form - Abandon
      window.rddl.marketo('exit', {
        event: 'form_abandon',
        mkto_form_id: 'form.marketo_form_id',
        form_name: '',
        form_field: 'form.fields_filled',
        form_url: 'page.url',
        client_id: 'user.client_id',
        munchkin_id: 'user.munchkin_id',
      });
    });
  })();
}

function initAlert() {
  $('.close').click(function () {
    $('.close').alert('close');
  });
}

function initFormCleaner() {
  const inputValue = jQuery('.form-search-roles input').attr('placeholder');
  let btn = jQuery('.form-search-roles .btn-clear-input');
  jQuery('.form-search-roles').change(' input', function () {
    jQuery('.form-search-roles').addClass('form-in-active');
  });
  btn.click(function () {
    jQuery('.form-search-roles').removeClass('form-in-active');
    jQuery('.form-search-roles input').val('');
    jQuery('.form-search-roles input').attr('placeholder', inputValue);
  });
}

function initListSort() {
  jQuery('.list-button').each(function () {
    if (jQuery('.list-button li').length == 4) {
      jQuery('.list-button').css('max-width', '630px');
    }
  });
}

function initHeaderHeight() {
  const header = jQuery('.siteHeader');
  const root = document.documentElement;

  function calcHeaderHeight() {
    var stickyHeight = header.outerHeight();
    root.style.setProperty('--header-height', stickyHeight + 'px');
  }

  calcHeaderHeight();

  window.addEventListener('resize', calcHeaderHeight);
}
